export default "/images/serdce-doma.png?e8b6296508ec13c105745e404974d410";